<template>
  <div>
    <v-card outlined id="wallet">
      <v-card-title
        class="d-flex flex-md-row flex-column justify-content-between"
      >
        <div class="text-lg"><span>کیف پول اعتباری</span></div>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-card outlined>
          <v-card-text>
            <div class="text-center" v-if="!showChargeCreditForm">
              <div class="text-site-color text-xl">
                <strong
                  v-if="
                    credit && credit.totalCredit.amount && credit.totalCredit
                  "
                >
                <span class="h2 text-primary">

                  {{ credit.totalCredit.amount | priceSplitter }}
                </span>
                  ریال
                </strong>
                <strong v-else> بدون شارژ</strong>
              </div>
              <div class="mt-3">
                <span class="text-sm">موجودی کیف پول اعتباری</span>
              </div>
              <div class="mt-3">
                <v-btn
                  class="px-8"
                  color="primary"
                  @click="openChargeCreditForm()"
                  v-if="!paymentForRetrayPay || paymentForRetrayPay.length <= 0"
                  >افزایش موجودی</v-btn
                >
              </div>
            </div>
            <div v-else class="d-flex flex-row justify-content-center">
              <div class="open-wallet-form">
                <div
                  class="d-flex flex-row justify-content-between border p-2 rounded"
                >
                  <div>موجودی</div>
                  <div>
                    <div class="text-site-color">
                      <strong
                        v-if="
                          credit &&
                          credit.totalCredit.amount &&
                          credit.totalCredit
                        "
                      >
                        {{ credit.totalCredit.amount | priceSplitter }}
                        ریال
                      </strong>
                      <strong v-else> بدون شارژ</strong>
                    </div>
                  </div>
                </div>
                <div class="mt-2">
                  <v-icon>mdi mdi-information-outline</v-icon>
                  <span>
                    موجودی کیف پول شما متعلق به شماره
                    {{ oidcUser.phone_number }} است .
                  </span>
                </div>
                <v-divider></v-divider>
                <v-row class="my-3">
                  <v-col
                    class="grow border rounded text-center mx-2 cursor-pointer"
                    @click="needPrice = 2000000"
                    >{{ '2000000' | priceSplitter }}
                  </v-col>
                  <v-col
                    class="grow border rounded text-center mx-2 cursor-pointer"
                    @click="needPrice = 1000000"
                  >
                    {{ '1000000' | priceSplitter }}
                  </v-col>
                  <v-col
                    class="grow border rounded text-center mx-2 cursor-pointer"
                    @click="needPrice = 500000"
                  >
                    {{ '500000' | priceSplitter }}
                  </v-col>
                </v-row>
                <div>
                  <wallet-form
                    sourceType="WalletCharge"
                    @closeCreditForm="closeCreditForm"
                    :needPrice="needPrice"
                    :retryRequest="retryRequest"
                    :selectedPaymentForRetryPay="selectedPaymentForRetryPay"
                  ></wallet-form>
                </div>
              </div>
            </div>
            <payment-for-retry-pay
              :payment-for-retray-pay="paymentForRetrayPay"
              @getPaymentForRetrayPay="getPaymentForRetrayPay"
              @openFormForRetryRequest="openFormForRetryRequest"
              v-if="
                paymentForRetrayPay &&
                paymentForRetrayPay.length > 0 &&
                !showChargeCreditForm
              "
            ></payment-for-retry-pay>
            <payment-status
              :succeed="succeed"
              :paymentId="paymentId"
              ref="PaymentStatusRef"
            ></payment-status>
          </v-card-text>
        </v-card>
        <v-divider></v-divider>
        <b class="text-base"> لیست تراکنش های کیف پول اعتباری </b>

        <wallet-transactions-list
          :walletTransactionsList="walletTransactionsList"
          :pageNumberProps="pageNumber"
          :itemsPerPageProps="itemsPerPage"
          @getAllWalletTransactions="getAllWalletTransactions"
        ></wallet-transactions-list>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import Helper from '@/core/helpers';
import WalletForm from './WalletForm.vue';
import { mapGetters } from 'vuex';
import PaymentStatus from './PaymentStatus.vue';
import { RepoFactory } from '@/baseRepository/Factory';
const walletTransactionsRepository = () =>
  RepoFactory.get('walletTransactions');
const paymentRepository = () => RepoFactory.get('payment');
import WalletTransactionsList from './WalletTransactionsList.vue';
import PaymentForRetryPay from './PaymentForRetryPay.vue';
export default {
  components: {
    WalletForm,
    PaymentStatus,
    WalletTransactionsList,
    PaymentForRetryPay,
  },
  data() {
    return {
      pageNumber: 1,
      itemsPerPage: 10,
      credit: null,
      showChargeCreditForm: false,
      needPrice: null,
      walletTransactionsList: null,
      paymentForRetrayPay: [],
      retryRequest: false,
      selectedPaymentForRetryPay: null,
    };
  },
  computed: {
    ...mapGetters('oidc', ['oidcUser']),
    succeed() {
      return this.$route.query.succeed == 'True'
        ? true
        : this.$route.query.succeed != 'True'
        ? false
        : undefined;
    },
    showWalletForm() {
      return this.$route.query.showWalletForm == 'True'
        ? true
        : this.$route.query.showWalletForm != 'True'
        ? false
        : undefined;
    },
    amount() {
      return this.$route.query.amount;
    },
    paymentId() {
      return this.$route.query.paymentId;
    },
  },
  async created() {
    this.getWalletTransactionsCredit();
    await this.getAllWalletTransactions(this.pageNumber, this.itemsPerPage);
    this.getPaymentForRetrayPay();
  },
  mounted() {
    if (this.amount) {
      this.needPrice = this.amount;
    }
    if (this.showWalletForm) {
      this.showChargeCreditForm = true;
    }
  },
  watch: {
    showChargeCreditForm(after, before) {
      if (!after) {
        this.$router.replace({ query: null });
        this.needPrice = null;
      }
    },
  },
  methods: {
    openFormForRetryRequest(item) {
      this.selectedPaymentForRetryPay = item;
      this.retryRequest = true;
      this.openChargeCreditForm();
    },
    getPaymentForRetrayPay() {
      paymentRepository()
        .getPaymentForRetrayPay(this.$store.getters['paymentBaseUrl'], {
          Authorization: 'Bearer ' + localStorage.getItem('access_token'),
        })
        .then((res) => {
          this.paymentForRetrayPay = res.data;
        })
        .catch((err) => {
          Helper.redirectPage(err, redirect);
        });
    },
    getAllWalletTransactions(pageNumber, itemsPerPage) {
      walletTransactionsRepository()
        .getAllWalletTransactions(
          this.$store.getters.walletBaseUrl,
          {},
          {
            PageNumber: pageNumber,
            ItemsPerPage: itemsPerPage,
          }
        )
        .then((res) => {
          this.walletTransactionsList = res.data;
        })
        .catch((err) => {
          Helper.handleErrors(err, this);
        });
    },
    openChargeCreditForm() {
      this.showChargeCreditForm = true;
      this.$refs.PaymentStatusRef.alert = false;
    },
    closeCreditForm() {
      this.showChargeCreditForm = false;
    },
    getWalletTransactionsCredit() {
      walletTransactionsRepository()
        .getWalletTransactionsCredit(this.$store.getters.walletBaseUrl)
        .then((res) => {
          this.credit = res.data;
        })
        .catch((error) => {
          Helper.handleErrors(error, this);
        });
    },
  },
};
</script>

<style scoped lang="scss">
.open-wallet-form {
  max-width: 600px;
}
</style>
